// extracted by mini-css-extract-plugin
export default {"wrapper":"otp_wrapper__0w-15"};